import { render, staticRenderFns } from "./DialogConfirmVerifiedPayment.vue?vue&type=template&id=a055d054&"
import script from "./DialogConfirmVerifiedPayment.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmVerifiedPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a055d054')) {
      api.createRecord('a055d054', component.options)
    } else {
      api.reload('a055d054', component.options)
    }
    module.hot.accept("./DialogConfirmVerifiedPayment.vue?vue&type=template&id=a055d054&", function () {
      api.rerender('a055d054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogConfirmVerifiedPayment.vue"
export default component.exports